/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Crown-Gold': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M2.667 9.333l8 4.267L16 6.667l6.667 6.933 6.666-4.267-1.333 16H4l-1.333-16z" _fill="#D7BC65"/><path pid="1" d="M14.32 22h4.45v-1.19h-1.39V14.6h-1.09c-.47.29-.98.48-1.72.62v.91h1.34v4.68h-1.59V22z" _fill="#fff"/>'
  }
})
